import Application from "../../Application";
import { IValueListService } from "../../service/valuelist/ValueListService";
import { IValueListItem } from "../../model/valuelist/ValueListItem";

export default class UpdateAttributeReferenceInteractor {
  private application: Application;
  private valueListService: IValueListService;

  constructor(application, valueListService) {
    this.application = application;
    this.valueListService = valueListService;
  }

  async execute(valueListItem: IValueListItem) {
    return this.valueListService.updateValue(valueListItem);
  }
}
